/* Premia — cart suggestions rail (drawer + cart page).
   Reads Shopify's Recommendations API (intent=complementary) — the same routine-first
   map the PDP block uses. Nothing is ever pre-selected; the customer taps to add.

   Loaded UNCONDITIONALLY from cart-drawer.liquid (and from the cart-page section), because
   the drawer markup arrives via innerHTML on the first add and injected <script> tags never
   execute. The guard below makes the double include harmless. */
(function () {
  if (window.__premiaCartRail) return;
  window.__premiaCartRail = true;

  var DEFAULT_MONEY = 'LE {{amount}}';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fmt(cents, f) {
    var n = (Number(cents || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return String(f || DEFAULT_MONEY).replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, n);
  }

  function msg(root, text, isErr) {
    var m = root.querySelector('.pcr__msg');
    if (!m) return;
    if (isErr) { m.setAttribute('data-err', '1'); } else { m.removeAttribute('data-err'); }
    m.textContent = text;
  }

  function bubble() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.cart-bubble').forEach(function (b) {
          b.classList.remove('visually-hidden');
          var n = b.querySelector('.cart-bubble__text-count');
          if (n) { n.classList.remove('hidden'); n.textContent = c.item_count; }
        });
      })
      .catch(function () {});
  }

  function card(p, root) {
    var f = root.getAttribute('data-money');
    var img = p.featured_image ? String(p.featured_image) : '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=260';
    var v = p.variants && p.variants[0] ? p.variants[0].id : '';
    var el = document.createElement('div');
    el.className = 'pcr__card';
    el.innerHTML =
      (img ? '<img class="pcr__img" src="' + img + '" alt="" loading="lazy">' : '') +
      '<span class="pcr__step">' + esc(p.type || 'Next step') + '</span>' +
      '<a class="pcr__nm" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<span class="pcr__pr">' + fmt(p.price, f) + '</span>' +
      '<button type="button" class="pcr__add" data-vid="' + esc(v) + '" aria-label="Add ' + esc(p.title) + ' to cart">+ Add</button>';
    return el;
  }

  function init(root) {
    if (root.getAttribute('data-init')) return;
    root.setAttribute('data-init', '1');
    var anchor = root.getAttribute('data-anchor');
    if (!anchor) return;
    var inCart = (root.getAttribute('data-incart') || '').split(',').filter(Boolean);
    var url = '/recommendations/products.json?product_id=' + encodeURIComponent(anchor) + '&limit=10&intent=complementary';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var list = (d.products || []).filter(function (p) {
          return p.available && inCart.indexOf(String(p.id)) === -1;
        }).slice(0, 3);
        if (!list.length) return;                       // already bought the routine, or nothing in stock
        var box = root.querySelector('.pcr__scroller');
        if (!box) return;
        box.innerHTML = '';
        list.forEach(function (p) { box.appendChild(card(p, root)); });
        root.hidden = false;
      })
      .catch(function () {});
  }

  /* Re-render the parts of the drawer the cart actually changed, WITHOUT replacing the
     <dialog> itself (that would slam it shut mid-interaction) and without dispatching
     cart:update (which would re-trigger the theme's auto-open).
     NOTE: the rail lives INSIDE .cart-drawer__items, so this swap replaces it with a fresh
     server-rendered shell — scan() at the end re-fills it, now excluding what was just added. */
  function swapDrawer(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    ['.cart-drawer__items', '.cart-drawer__summary', '.cart-drawer__heading'].forEach(function (sel) {
      var live = document.querySelector(sel), fresh = doc.querySelector(sel);
      if (live && fresh) live.innerHTML = fresh.innerHTML;
    });
    var fa = document.getElementById('FreeShippingBar'), fb = doc.getElementById('FreeShippingBar');
    if (fa && fb) { fa.className = fb.className; fa.innerHTML = fb.innerHTML; }
    bubble();
    scan();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.pcr__add');
    if (!b) return;
    e.preventDefault();
    if (b.hasAttribute('data-done') || b.disabled) return;
    var root = b.closest('.pcr');
    var id = b.getAttribute('data-vid');
    if (!root || !id) return;

    b.disabled = true;
    b.textContent = 'Adding';
    var isPage = root.getAttribute('data-mode') === 'page';
    var sid = root.getAttribute('data-section');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (!isPage && sid) { body.sections = sid; body.sections_url = window.location.pathname; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (res) {
        b.setAttribute('data-done', '1');
        b.textContent = 'Added';
        b.disabled = false;
        msg(root, 'Added to your bag', false);
        if (isPage) { window.location.reload(); return; }
        if (res.sections && sid && res.sections[sid]) { swapDrawer(res.sections[sid]); } else { bubble(); }
      })
      .catch(function () {
        b.disabled = false;
        b.textContent = '+ Add';
        msg(root, 'Could not add — please try again', true);
      });
  });

  function scan() {
    document.querySelectorAll('.pcr').forEach(init);
  }

  /* The drawer can be re-rendered by the theme at any point after a cart change and the
     timing is not guaranteed — so re-scan a few times rather than betting on one delay. */
  function scanSoon() { [60, 300, 900, 1800].forEach(function (d) { setTimeout(scan, d); }); }

  document.addEventListener('cart:update', scanSoon);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.header-actions__action')) scanSoon();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
